import { gql } from "@apollo/client";

const GET_COURSE_DETAILS = gql`
  query GetCourseDetails($id: ID!) {
    courseDetails(id: $id) {
      id
      lessons {
        id
        course {
          credits
        }
        date
        time
        classType
        classSize
        category
        seatsRemaining
        bookedAt
        startTime
        overlapped
        completed
        rated
        credits
        language {
          id
          englishName
          realName
          bannerBackground
        }
        teacher {
          id
          avatar
          givenName
          familyName
        }
        topic {
          id
          title
        }
        chapter {
          name
        }
        level {
          title
        }
        city {
          id
          name
        }
      }
    }
  }
`;

export default GET_COURSE_DETAILS;
